import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    isShowBg: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      list: ['影片详情', '云首发特权', '大咖推荐', '云首发详情']
    };
  },
  methods: {
    select: function select(k) {
      this.$emit('select', k);
    }
  }
};